export const DRIVER_SUSPENSION_POLICY = {
  id: 'driver-suspension-policy',
  title: 'Driver Suspension and Termination Policy',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'driver',
  content: `DRIVER SUSPENSION AND TERMINATION POLICY — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This policy sets out the grounds, procedure, and appeal rights for the suspension or termination of a Driver's authorisation to accept bookings on the Reservo platform.

2. GROUNDS

2.1 Reservo may suspend or terminate a Driver immediately and without prior notice where:
  (a) the Driver's NSW driver licence, NSW Driver Authorisation, Working With Children Check (where required), vehicle authorisation, or insurance lapses, is suspended, or is cancelled;
  (b) the Driver fails a drug or alcohol test or refuses such a test;
  (c) the Driver is charged with or convicted of an offence relating to safety, sexual conduct, child welfare, violence, fraud, or dishonesty;
  (d) the Driver causes or threatens physical or sexual harm to a passenger, third party, or Reservo personnel;
  (e) a substantiated complaint of discrimination is made against the Driver;
  (f) the Driver refuses to carry a guide or support animal or otherwise commits a disability-discrimination act;
  (g) the Driver engages in fraud against Reservo, a passenger, or Stripe;
  (h) the Driver takes bookings off the Reservo platform after being introduced through Reservo;
  (i) the Driver manipulates the rewards program, ratings, or fare calculation;
  (j) the Driver submits a false or grossly exaggerated damage or cleaning claim;
  (k) the Driver fails to report a Notifiable Occurrence;
  (l) the Driver impersonates another person;
  (m) the Driver shares their account with another person;
  (n) the Driver fails to comply with a direction of the NSW Point to Point Transport Commissioner.

2.2 Reservo may suspend or terminate a Driver with notice for:
  (a) repeated cancellations within 2 hours of scheduled pickup;
  (b) consistently low Rider ratings;
  (c) repeated complaints not individually rising to immediate suspension;
  (d) failure to complete annual training or re-check requirements;
  (e) failure to maintain a clean and safe vehicle;
  (f) any other persistent breach of the Driver Agreement or Code of Conduct.

3. PROCEDURE — IMMEDIATE SUSPENSION

3.1 When immediate suspension is required:
  (a) the Driver's account is suspended in the platform;
  (b) any active bookings are reassigned or, if reassignment is not possible, cancelled;
  (c) the Driver is notified by SMS and email with reasons;
  (d) the Driver may not accept new bookings during suspension.

3.2 The Reservo Operator (David Williams) conducts a review of the suspension within 7 days.

4. PROCEDURE — NON-IMMEDIATE SUSPENSION OR TERMINATION

4.1 Where suspension or termination is being considered for a non-urgent ground:
  (a) the Driver receives written notice of the matter and the proposed action;
  (b) the Driver has 7 days to respond in writing or by phone;
  (c) the Operator considers the Driver's response;
  (d) a decision is made and communicated in writing.

5. INVESTIGATION

5.1 Where investigation is required:
  (a) the Operations team gathers evidence (trip records, messages, ratings, dashcam, witness statements, regulator advice);
  (b) the Driver is given a fair opportunity to respond;
  (c) findings are documented in the disciplinary register;
  (d) outcome is determined by the Operator.

6. POSSIBLE OUTCOMES

6.1 Available outcomes include:
  (a) no action;
  (b) verbal warning;
  (c) written warning;
  (d) mandatory training;
  (e) probationary period;
  (f) tier downgrade (gold / silver / bronze / probation);
  (g) suspension for a defined period;
  (h) permanent termination;
  (i) referral to NSW Police;
  (j) referral to the NSW Point to Point Transport Commissioner;
  (k) referral to anti-discrimination authorities;
  (l) clawback of rewards or payouts.

7. APPEAL

7.1 A Driver may appeal a suspension or termination decision by writing to admin@reservo.au within 30 days of the decision.

7.2 The appeal:
  (a) sets out the grounds;
  (b) attaches any additional evidence;
  (c) is reviewed by the Operator or, in matters where the Operator is conflicted, by an independent reviewer.

7.3 The appeal is decided within 14 days. The decision is final.

7.4 The Driver may also pursue:
  (a) the NSW Point to Point Transport Commissioner for matters within its jurisdiction;
  (b) the Fair Work Commission or other tribunal where applicable;
  (c) civil remedies.

8. EFFECT OF TERMINATION

8.1 On termination:
  (a) the Driver's account is permanently disabled;
  (b) any pending payouts are finalised after deduction of any owed amounts;
  (c) rewards points for the current period are forfeited if termination is for serious breach;
  (d) data is retained per the Data Retention Policy;
  (e) the Driver may not re-register without express approval of the Operator.

9. REPORTING TO REGULATORS

9.1 Reservo notifies the NSW Point to Point Transport Commissioner of suspensions or terminations where:
  (a) the underlying matter is a Notifiable Occurrence;
  (b) the matter concerns safety, fraud, or discrimination;
  (c) the Commissioner has directed such notification.

10. RECORDS

10.1 All suspensions, terminations, and appeals are recorded in the disciplinary register, retained for 7 years.

11. REVIEW

11.1 This policy is reviewed at least annually and after any significant disciplinary matter.

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};